// src/pages/EmailSent.jsx
import React from "react";
import "../styles/register.css";

const EmailSent = () => (
  <div className="register-page">
    <div className="register-info">
      <h1>📬 E-mail enviado!</h1>
      <p>Verifique sua caixa e-mail para concluir o cadastro.</p>
    </div>
  </div>
);

export default EmailSent;
